<div class="panel-title">
  Today's Outstanding Amounts
</div>

<form [formGroup]="todayOutstanding" class="td-body">
  <div class="d-flex header">

    <div class="left-panel">
      <div class="d-flex title">
        <div>Currency</div>
        <div class="ml-auto" (click)="sort('currency')">
          <div class="sort-column" *ngIf="!sortCurrency">
            <i class="fa fa-angle-up"></i>
            <i class="fa fa-angle-down"></i>
          </div>
          <i class="fa" *ngIf="sortCurrency" [ngClass]="{
                                    'fa-angle-down': sortCurrency === 'desc',
                                    'fa-angle-up': sortCurrency === 'asc'
                                  }"></i>
        </div>
      </div>
      <input class="search-currency" placeholder="Search" type="text" formControlName="currency">
    </div>

    <div class="right-panel">
      <div class="d-flex title">
        <div>Amount</div>
        <div class="ml-auto" (click)="sort('amount')">
          <div class="sort-column" *ngIf="!sortAmount">
            <i class="fa fa-angle-up"></i>
            <i class="fa fa-angle-down"></i>
          </div>
          <i class="fa" *ngIf="sortAmount" [ngClass]="{
                                      'fa-angle-down': sortAmount === 'desc',
                                      'fa-angle-up': sortAmount === 'asc'
                                    }"></i>
        </div>
      </div>
      <input placeholder="Search" type="text" formControlName="amount" npInputMask [options]="{
        numeral: true,
        numeralIntegerScale: 255
      }" (keypress)="$event.charCode !== 45" class="search-amount">
    </div>
  </div>

  <div class="d-flex body" [ngClass]="{'scroll': data.length > 11, 'no-scroll': data.length < 12}">
    <div class="left-panel">
      <div class="currency-list list">
        <ng-container *ngIf="data.length > 0">
          <ng-container *ngFor="let item of data">
            <div class="d-flex item" (click)="getClientOutstandingTrade(item)">
              <span [class]="item.currencyCode | flagIcon"></span>&nbsp;&nbsp;
              <span>{{item.currencyCode}}</span>
            </div>
          </ng-container>
        </ng-container>
        <ng-container *ngIf="data.length === 0 && !isLoading">
          <div class="no-result">
            No result found
          </div>
        </ng-container>
      </div>
    </div>

    <div class="right-panel">
      <div class="amount-list list">
        <ng-container *ngIf="data.length > 0">
          <ng-container *ngFor="let item of data">
            <div class="item" [class.negative-amount]="item.amount < 0" (click)="getClientOutstandingTrade(item)">{{item.amount | transformNumber}}</div>
          </ng-container>
        </ng-container>
        <ng-container *ngIf="data.length === 0  && !isLoading">
          <div class="no-result">
            No result found
          </div>
        </ng-container>
      </div>
    </div>
  </div>
</form>